export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'paramID',
    align: 'left',
    width: 200,
    title: '参数ID',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'paramName',
    align: 'left',
    width: 200,
    title: '参数名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'paramValue',
    align: 'left',
    minWidth: 500,
    title: '参数值',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'paramStatusName',
    align: 'center',
    width: 100,
    title: '参数状态',
    slots: {default: 'status'},
  },
  {
    field: 'paramDescription',
    align: 'left',
    minWidth: 300,
    title: '参数说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  }
  
]
